import { HelpItemType } from "../constants.js";
import { HelpContainerTiles } from "../help-shared/help-container.jsx";
import { HelpArticle } from "./help-article.jsx";
import { useArticleCopyState } from "../hooks/useHelpCopyState.jsx";

export function HelpArticleRenderer(props) {
    const {
        Visible, SelectedItem, Title, Description,
        Articles, HelpSiteViewBaseUrl, ProductName, Theme,
        ChangeSelectedItem, OnClickRelated, BaseUrl, CopyState
    } = props;

    //const getAiChatAttachment = () => {
    //    let attachment = Name + "\n\n";
    //    if (Description) {
    //        attachment = attachment + Description + "\n\n";
    //    }
    //    for (let i = 0, len = Items.length; i < len; i++) {
    //        attachment = attachment + Items[i].value + "\n";
    //    }
    //    return attachment;
    //};

    //const openAiChatSidebar = () => {
    //    const prompt = {
    //        Prompt: "I would like to ask questions about this article",
    //        Attachment: getAiChatAttachment()
    //    }
    //    OpenAiChatSidebar(prompt);
    //};

    const copyState = useArticleCopyState({
        Ignore: Boolean(CopyState || Theme === "web"),
        SelectedArticle: SelectedItem,
        HelpSiteViewBaseUrl: HelpSiteViewBaseUrl,
        Title: Title,
        Description: Description,
        Articles: Articles
    });

    if (Visible === false)
        return null;

    return (<>
        <HelpContainerTiles
            CopyState={CopyState ?? copyState}
            Visible={SelectedItem === null}
            Theme={Theme}
            Name={Title}
            Description={Description}
            ProductName={ProductName}
            HideTileDescriptions={Theme !== "web"}
            Tiles={Articles}
            OnClick={(tile) => ChangeSelectedItem(tile.Slug, HelpItemType.Article, tile.PinToTop ? tile.Slug : null)} />
        <HelpArticle
            CopyState={CopyState ?? copyState}
            Visible={SelectedItem !== null}
            Theme={Theme}
            Name={SelectedItem?.Title}
            Description={SelectedItem?.Description}
            Articles={SelectedItem?.Articles}
            Items={SelectedItem?.Items}
            RelatedArticles={SelectedItem?.RelatedArticles}
            ProductName={ProductName}
            BaseUrl={BaseUrl}
            OnClick={ChangeSelectedItem}
            OnClickRelated={OnClickRelated} />
    </>);
}
